import React from 'react'

import SignalIntentCalculator from './SignalIntentCalculator'

const MortgageCalculatorBlock = () => {
  return <SignalIntentCalculator Guid='fc4c3059-1083-425e-a4dc-6f0c5b4d1fba' />
}

export default React.memo(MortgageCalculatorBlock)
